import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastInput } from '../ui/components/Toast';
import { v4 } from 'uuid';

export const toastSlice = createSlice({
  name: 'toast',
  initialState: { key: v4() },
  reducers: {
    render(state, action: PayloadAction<void>) {
      state.key = v4();
    },
  },
});

export const toastState = {
  items: new Map<string, ToastInput>(),
};
